import app from 'flarum/forum/app';

export default function changeAuthorsListPath() {
  app.routes['virtualAuthors.list'].path = '/about-us';
}
